import { render, staticRenderFns } from "./CMCourseRemove.vue?vue&type=template&id=a5adaf3c&lang=pug"
import script from "./CMCourseRemove.vue?vue&type=script&lang=js"
export * from "./CMCourseRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports